export default __webpack_public_path__ + "static/media/employers.a569e7be.svg";